import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_113: DocMigration = {
  maxSchemaVersion: "0.0.113",
  description: "Basements",
  apply(json: any) {
    if (json.rooms) {
      for (const roomId in json.rooms) {
        const room = json.rooms[roomId];
        if (room.attributes?.roomClass !== undefined) {
          // insert RoomType.DECK at index 4;
          if (room.attributes.roomClass > 3) {
            room.attributes.roomClass = room.attributes.roomClass + 1;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_113;
